/* eslint-disable max-len */
/* global isEmpty */
/* eslint-disable max-statements, complexity, no-use-before-define, max-depth, no-shadow, wrap-iife, key-spacing */
(function($) {
  'use strict';

  var tick =
    '<span class="compare-slider__tick"><svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg"><title>Checked</title><g clip-rule="evenodd" fill-rule="evenodd"><path d="m8.87977.00081792c-4.97019.06652148-8.9450876 4.14996208-8.87895666 9.12029208.06652226 4.96819 4.14961666 8.94419 9.11960666 8.87809 4.96918-.0669 8.94488-4.1504 8.87878-9.12031-.0665-4.96856-4.1498-8.9443979-9.11943-8.87807208z" fill="#7ab800"/><path d="m12.7615 5-5.50712 5.9123-2.20465-2.54064-1.04973.92063 3.21677 3.70771 6.56103-7.04297z" fill="#000"/></g></svg></span>';

  var cross =
    '<span class="compare-slider__cross"><svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg"><title>Not checked</title><path clip-rule="evenodd" d="m8.87977.00081792c-4.97019.06652148-8.9450876 4.14996208-8.87895666 9.12029208.06652226 4.96819 4.14961666 8.94419 9.11960666 8.87809 4.96918-.0669 8.94488-4.1504 8.87878-9.12031-.0665-4.96856-4.1498-8.9443979-9.11943-8.87807208z" fill="#999" fill-rule="evenodd"/><g stroke="#fff" stroke-width="1.5"><path d="m12.5303 5.53033-6.99997 6.99997"/><path d="m12.4697 12.5303-7.00003-6.99997"/></g></svg></span>';

  var $compareSlider = {
    $slider: $('.js-compare-slider'),
    $sliderSticky: $('.js-compare-slider-sticky'),
    $controlLeft: $('.js-compare-control-left'),
    $controlRight: $('.js-compare-control-right'),
    $heading: $('.js-compare-slider-heading'),
    $subText: $('.js-compare-slider-subtext'),
    $icon: $('.js-compare-slider-icon'),
    $showing: $('.js-compare-slider-showing'),
    resizingTimer: '',
    scrolling: false,
  };

  var studyLink = $('.compare-slider').data('studyLink');

  /**
   * Update the sliders show and scroll options
   * This is required in a separate function because the options inside the slider
   * cause thousands of warnings bogging down browsers
   */
  function updateSliders() {
    if ($(window).width() > 959) {
      $compareSlider.$slider.slick('slickSetOption', 'slidesToShow', 3);
      $compareSlider.$slider.slick('slickSetOption', 'slidesToScroll', 3);
      $compareSlider.$sliderSticky.slick('slickSetOption', 'slidesToShow', 3);
      $compareSlider.$sliderSticky.slick('slickSetOption', 'slidesToScroll', 3);
    } else if ($(window).width() > 599) {
      $compareSlider.$slider.slick('slickSetOption', 'slidesToShow', 2);
      $compareSlider.$slider.slick('slickSetOption', 'slidesToScroll', 2);
      $compareSlider.$sliderSticky.slick('slickSetOption', 'slidesToShow', 2);
      $compareSlider.$sliderSticky.slick('slickSetOption', 'slidesToScroll', 2);
    } else {
      $compareSlider.$slider.slick('slickSetOption', 'slidesToShow', 1);
      $compareSlider.$slider.slick('slickSetOption', 'slidesToScroll', 1);
      $compareSlider.$sliderSticky.slick('slickSetOption', 'slidesToShow', 1);
      $compareSlider.$sliderSticky.slick('slickSetOption', 'slidesToScroll', 1);
    }

    $compareSlider.$slider.slick(
      'slickGoTo',
      $compareSlider.$slider.slick('slickCurrentSlide')
    );
    $compareSlider.$sliderSticky.slick(
      'slickGoTo',
      $compareSlider.$sliderSticky.slick('slickCurrentSlide')
    );
  }

  /**
   * Checks if the current scroll position should toggle the sticky or not
   */
  function checkSticky() {
    var $headerRows = $(
      $compareSlider.$slider.find('.compare-slider__item-row--header')
    );

    if ($headerRows.length) {
      var headerBottom = $headerRows.offset().top + $headerRows.outerHeight(),
        $items = $compareSlider.$slider.find('.compare-slider__item'),
        itemBottom =
          $items.offset().top +
          $items.outerHeight() -
          $headerRows.outerHeight(),
        scroll = $(window).scrollTop();

      if (scroll > headerBottom && scroll < itemBottom) {
        $compareSlider.$sliderSticky.removeClass('stickyhidden');
      } else {
        $compareSlider.$sliderSticky.addClass('stickyhidden');
      }
    }
  }

  /**
   * Updates the showing information of the slider
   */
  function updateShowingInfo() {
    var $list = $compareSlider.$slider.find('.slick-track'),
      $active = $list.find('.slick-active'),
      $all = $compareSlider.$slider.find('.compare-slider__item'),
      $dotsMain = $('.js-compare-slider-dots-main'),
      start = $all.index($active[0]) + 1,
      end = $all.index($active[$active.length - 1]) + 1,
      total = $all.length,
      studyLinkHTML =
        '<a href="' +
        studyLink +
        '" class="btn btn--green compare-slider__find-btn">Find courses</a>',
      $findCta = $(studyLinkHTML);

    $compareSlider.$showing.html(
      total > 0
        ? 'Showing ' + start + ' - ' + end + ' of ' + total + ' courses'
        : studyLinkHTML
    );

    if (total > 0) {
      $findCta.remove();
    } else if (!$dotsMain.has('.compare-slider__find-btn').length) {
      $findCta.prependTo($dotsMain);
    }

    $compareSlider.$heading.text(
      total > 0
        ? $compareSlider.$heading.text().replace(/[X0-9]+/g, total)
        : 'Your compare courses list is empty!'
    );
    $compareSlider.$subText.html(
      total > 0
        ? $compareSlider.$subText.html().replace(/[X0-9]+/g, total)
        : 'Add courses to your Compare list to view the differences between the courses of interest to you.<br>' +
          'You will be able to add to your compare list wherever you see the Compare symbol on course pages, course lists, and search results.'
    );
    $compareSlider.$icon.html(
      total > 0
        ? $compareSlider.$icon.html().replace(/[X0-9]+/g, total)
        : '<svg aria-labelledby="compare-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18"><title id="compare-icon" lang="en">Compare Icon</title><path d="M0 4.998h4.868V0H0v4.998zm1.29-3.674h2.289v2.35h-2.29v-2.35zM6.415 0v4.998H22V0H6.415zm14.296 3.675H7.704V1.324h13.007v2.35zM0 11.484h4.868V6.486H0v4.998zm1.29-3.675h2.289v2.351h-2.29V7.81zm5.125 3.675H22V6.486H6.415v4.998zm1.29-3.675H20.71v2.351H7.704V7.81zM0 17.97h4.868v-5H0v4.998zm1.29-3.675h2.289v2.35h-2.29v-2.35zm5.125 3.675H22v-5H6.415v4.998zm1.29-3.675H20.71v2.35H7.704v-2.35z" fill="currentColor"/></svg>'
    );
  }

  /**
   * Takes a list of jQuery objects and finds the largest height item
   * Then makes all items match the same height
   * @param {jQuery} $items
   */
  function alignRows($items) {
    var largest = 0;

    $items.each(function(index, elem) {
      // Remove styles on the element and check it's original height
      var currentHeight = $(elem).outerHeight();
      $(elem).removeAttr('style');
      var pureHeight = $(elem).outerHeight();
      $(elem).css('height', currentHeight);

      largest = pureHeight > largest ? pureHeight : largest;
    });

    $items.each(function(index, elem) {
      $(elem).css('height', largest);
    });
  }

  /**
   * Updates all rows of the slider so that their heights match
   */
  function updateAllRows() {
    for (var i = 1; i < 99; i += 1) {
      var $rows = $('.compare-slider [data-row="' + i + '"]');

      if ($rows.length < 1) {
        // No more rows, stop checki
        break;
      }

      alignRows($rows);
    }
  }

  function updateCompareCounter() {
    if ($('.js-sticky-widget-compare').length) {
      if (typeof localStorage.comparedCourses !== 'undefined') {
        $('.js-sticky-widget-compare').text(
          Object.keys(JSON.parse(localStorage.getItem('comparedCourses')))
            .length
        );
      }
    }
  }

  function updateSavedCounter() {
    if ($('.js-sticky-widget-saved').length) {
      if (typeof localStorage.savedCourses !== 'undefined') {
        $('.js-sticky-widget-saved').text(
          Object.keys(JSON.parse(localStorage.getItem('savedCourses'))).length
        );
      }
    }
  }

  function addCourse(localStorageName, courseId, courseInfo) {
    var localStorageItem = {};

    if (typeof localStorage[localStorageName] !== 'undefined') {
      localStorageItem = JSON.parse(localStorage.getItem(localStorageName));
    }

    localStorageItem[courseId] = courseInfo;
    localStorage.setItem(localStorageName, JSON.stringify(localStorageItem));

    updateCompareCounter();
    updateSavedCounter();
  }

  function removeCourse(localStorageName, courseId) {
    var localStorageItem = {};

    if (typeof localStorage[localStorageName] !== 'undefined') {
      localStorageItem = JSON.parse(localStorage.getItem(localStorageName));
    }

    if (localStorageItem.hasOwnProperty(courseId)) {
      delete localStorageItem[courseId];
    }

    localStorage.setItem(localStorageName, JSON.stringify(localStorageItem));

    updateCompareCounter();
    updateSavedCounter();
  }

  function populateComparedTemplate(
    $courseTemplate,
    courseId,
    courseInfo,
    courseSaved
  ) {
    var $courseSavedButton = $courseTemplate.find('.js-compare-control-save'),
      $courseRemoveButton = $courseTemplate.find('.js-compare-control-close');

    $courseSavedButton.attr({
      'data-gtm-event': 'Save',
      'data-gtm-value': courseInfo.link,
    });

    $courseRemoveButton.attr({
      'data-gtm-event': 'Remove from compare',
      'data-gtm-value': courseInfo.link,
    });

    if (courseSaved) {
      $courseSavedButton.addClass('active').attr('aria-pressed', 'true');
    }

    $courseSavedButton.click(function() {
      if ($courseSavedButton.hasClass('active')) {
        $courseSavedButton.removeClass('active').attr('aria-pressed', 'false');
        removeCourse('savedCourses', courseId);
      } else {
        $courseSavedButton.addClass('active').attr('aria-pressed', 'true');
        addCourse(
          'savedCourses',
          courseId,
          encodeURIComponent(JSON.stringify(courseInfo))
        );
      }
    });

    $courseRemoveButton.click(function(e) {
      removeCourse('comparedCourses', courseId);

      var $target = $($(e.target).closest('.compare-slider__item')),
        $mainItems = $compareSlider.$slider.find('.compare-slider__item'),
        $stickyItems = $compareSlider.$sliderSticky.find(
          '.compare-slider__item'
        ),
        mainIndex = $mainItems.index($target),
        stickyIndex = $stickyItems.index($target);

      if (mainIndex > -1) {
        $compareSlider.$slider.slick('slickRemove', mainIndex);
        $compareSlider.$sliderSticky.slick('slickRemove', mainIndex);
      }
      if (stickyIndex > -1) {
        $compareSlider.$slider.slick('slickRemove', stickyIndex);
        $compareSlider.$sliderSticky.slick('slickRemove', stickyIndex);
      }

      updateShowingInfo();
    });

    $courseTemplate
      .attr('data-course-id', courseId)
      .attr('data-course-info', encodeURIComponent(JSON.stringify(courseInfo)))
      .find('[data-field]')
      .each(function() {
        var $field = $(this),
          fieldName = $field.attr('data-field'),
          fieldType = $field.attr('data-field-type');

        switch (fieldType) {
        case 'html':
          $field.html(courseInfo[fieldName]);
          break;
        case 'string':
          if (!courseInfo[fieldName]) {
            $field.parent('div:not([class])').remove();
          } else {
            $field.text(courseInfo[fieldName]);
          }
          break;
        case 'link':
          if (fieldName === 'entry-requirements-link') {
            $field.attr('href', courseInfo.link + '#entry-requirements');
          } else {
            $field.attr('href', courseInfo[fieldName]);
          }
          break;
        case 'group':
          var listHtml = '';
          $.each(courseInfo[fieldName], function(
            listItemName,
            listItemStatus
          ) {
            listHtml += '<div><span>' + listItemName + '</span>';
            if (listItemStatus) {
              listHtml += tick;
            } else {
              listHtml += cross;
            }
            listHtml += '</div>';
          });
          $field.html(listHtml);
          break;
        case 'list':
          var listHtml = '';
          $.each(courseInfo[fieldName], function(_index, listItemName) {
            var item = listItemName;
            if (Array.isArray(item) && item.length > 1) {
              item = item.join('</span> <span>');
            }
            listHtml += '<div>\n<span>' + item + '</span>\n</div>';
          });
          $field.replaceWith(listHtml);
          break;
        case 'boolean':
          if (courseInfo[fieldName]) {
            $field.html(tick);
          } else {
            $field.html(cross);
          }
          break;
        }
      });

    $courseTemplate.find('[data-hide-if-empty]').each(function() {
      var $el = $(this),
        fieldNames = $el.attr('data-hide-if-empty'),
        fields;

      fields = fieldNames.split(';').reduce(function(obj, fieldName) {
        obj[fieldName] = courseInfo[fieldName];
        return obj;
      }, {});

      if (isEmpty(fields)) {
        $el.remove();
      }
    });

    $courseTemplate.find('[data-show-if-empty]').each(function() {
      var $el = $(this),
        fieldNames = $el.attr('data-show-if-empty'),
        fields;

      fields = fieldNames.split(';').reduce(function(obj, fieldName) {
        obj[fieldName] = courseInfo[fieldName];
        return obj;
      }, {});

      if (!isEmpty(fields)) {
        $el.remove();
      }
    });

    return $courseTemplate;
  }

  function createComparedCourses() {
    var $compareCoursesResultsStickyContainer = $('.js-compare-slider-sticky'),
      $compareCoursesResultsStickyTemplate = $compareCoursesResultsStickyContainer
        .find('.compare-slider__item--template')
        .clone()
        .removeClass('compare-slider__item--template'),
      $compareCoursesResultsContainer = $('.js-compare-slider'),
      $compareCoursesResultsTemplate = $compareCoursesResultsContainer
        .find('.compare-slider__item--template')
        .clone()
        .removeClass('compare-slider__item--template'),
      savedCourses = {};

    $compareCoursesResultsStickyContainer.empty();
    $compareCoursesResultsContainer.empty();

    if (typeof localStorage.comparedCourses !== 'undefined') {
      var comparedCourses = JSON.parse(localStorage.getItem('comparedCourses'));

      if (typeof localStorage.savedCourses !== 'undefined') {
        savedCourses = JSON.parse(localStorage.getItem('savedCourses'));
      }

      if (!$.isEmptyObject(comparedCourses)) {
        $.each(comparedCourses, function(courseId, data) {
          var courseInfo = JSON.parse(decodeURIComponent(data)),
            courseSaved = savedCourses.hasOwnProperty(courseId),
            $comparedCourseSticky = populateComparedTemplate(
              $compareCoursesResultsStickyTemplate.clone(),
              courseId,
              courseInfo,
              courseSaved
            ),
            $comparedCourse = populateComparedTemplate(
              $compareCoursesResultsTemplate.clone(),
              courseId,
              courseInfo,
              courseSaved
            );

          $compareCoursesResultsStickyContainer.append($comparedCourseSticky);
          $compareCoursesResultsContainer.append($comparedCourse);
        });
      }
    }
  }

  // Only initialise if slider found
  if ($compareSlider.$slider.length > 0) {
    createComparedCourses();

    $compareSlider.$slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 300,
      arrows: true,
      dots: true,
      centerMode: false,
      infinite: false,
      variableWidth: false,
      appendDots: $('.js-compare-slider-dots-main'),
      asNavFor: $compareSlider.$sliderSticky,
      prevArrow: $compareSlider.$controlLeft,
      nextArrow: $compareSlider.$controlRight,
      // mobileFirst: true,
      // responsive: [{
      //     breakpoint: 599,
      //     settings: {
      //       slidesToShow: 2,
      //       slidesToScroll: 2
      //     }
      //   },
      //   {
      //     breakpoint: 959,
      //     settings: {
      //       slidesToShow: 3,
      //       slidesToScroll: 3
      //     }
      //   }
      // ]
    });

    $compareSlider.$sliderSticky.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 300,
      arrows: false,
      dots: true,
      centerMode: false,
      infinite: false,
      variableWidth: false,
      appendDots: $('.js-compare-slider-dots-secondary'),
      asNavFor: $compareSlider.$slider,
    });

    // Init slick events
    $compareSlider.$slider.on('afterChange', function() {
      updateShowingInfo();
    });

    $compareSlider.$slider.on('setPosition', function() {
      updateAllRows();
    });

    // Init resize events
    $(window).on('resize', function() {
      checkSticky();

      this.clearTimeout($compareSlider.resizingTimer);

      $compareSlider.resizingTimer = this.setTimeout(function() {
        updateSliders();
        updateAllRows();
      }, 300);
    });

    // Init scroll events
    $(window).on('scroll', function() {
      if (!$compareSlider.scrolling) {
        $compareSlider.scrolling = true;

        checkSticky();

        this.setTimeout(function() {
          $compareSlider.scrolling = false;
        }, 100);
      }
    });

    $(window).on('ready', function() {
      updateAllRows();
    });

    // Init mousedown events
    $compareSlider.$controlLeft.on('mousedown', function(e) {
      e.preventDefault();
    });
    $compareSlider.$controlRight.on('mousedown', function(e) {
      e.preventDefault();
    });

    // Init slider options
    updateSliders();

    // Init showing info
    updateShowingInfo();

    // Init row heights
    updateAllRows();

    // Init sticky header
    checkSticky();
  }
})(jQuery);
